(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultMissingDataDeleteController',PatientResultMissingDataDeleteController);

    PatientResultMissingDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientResultMissingData'];

    function PatientResultMissingDataDeleteController($uibModalInstance, entity, PatientResultMissingData) {
        var vm = this;

        vm.patientResultMissingData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientResultMissingData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
